module.exports = __webpack_public_path__ + "static/media/edit_profile.4e78740f.svg";